import { render } from "./AboutSectionHome.vue?vue&type=template&id=c3d80ed2&scoped=true"
import script from "./AboutSectionHome.vue?vue&type=script&lang=js"
export * from "./AboutSectionHome.vue?vue&type=script&lang=js"

import "./AboutSectionHome.vue?vue&type=style&index=0&id=c3d80ed2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d80ed2"]])

export default __exports__